var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"goTop"}}),_c('router-view'),_c('a',{attrs:{"href":"#goTop"}},[_c('img',{class:['_img', _vm.currentScroll > 400 ? 'current' : ''],attrs:{"src":require("./assets/top.jpg"),"alt":""}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }